import "../App.css"
import { headerStyling } from "../App";
import { Link } from "react-router";
import { Component } from "react";
import scribble from '../images/scribble3.png'


class PlaylistWidget extends Component {
    render() {
        return (
            <>
                <iframe
                    style={{
                        width: "min(100%,600px)"
                    }}
                    height="300"
                    scrolling="no"
                    frameBorder="no"
                    allow="autoplay"
                    title="soundcloud-player"
                    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2008550670%3Fsecret_token%3Ds-HcF18waFocg&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true">
                </iframe>
                <div
                    style={{
                        fontSize: "10px",
                        color: "#cccccc",
                        lineBreak: "anywhere",
                        wordBreak: "normal",
                        overflow: "hidden",
                        whiteSpace: "nowrap", textOverflow: "ellipsis",
                        fontFamily: "Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif",
                        fontWeight: "100"
                    }}
                >
                    <a href="https://soundcloud.com/bhargav-anni"
                        title="Bhargav Annigeri"
                        // target="_blank"
                        style={{
                            color: "#cccccc",
                            textDecoration: "none"
                        }}
                    >
                        Bhargav Annigeri
                    </a> ·
                    <a href="https://soundcloud.com/bhargav-anni/sets/my-work/s-HcF18waFocg"
                        title="My Work"
                        // target="_blank"
                        style={{
                            color: "#cccccc",
                            textDecoration: "none"
                        }}> Example Client Work</a>
                </div>
            </>
        );
    }
}

class BandcampWidget extends Component {
    render() {
        return (
            <iframe
                style={{ border: 0, width: "100%", height: "120px", }}
                src="https://bandcamp.com/EmbeddedPlayer/album=532134906/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/"
                seamless
                title="bandcamp-player">
                <a href="https://fivemangotrees.bandcamp.com/album/tiger-balm">
                    tiger balm by five mango trees
                </a>
            </iframe>
        )
    }
}

function Work() {
    return (
        <div className="App-body">
            <p>
                I'm up to a few different endeavors!
            </p>
            <hr />
            <p style={headerStyling}>
                Music
            </p>
            <p>
                I produce and compose on a freelance basis for a variety of projects. 
                I work in all sorts of genres; most of my experience is in hip-hop beatmaking, but I also make music in alternative, rock, dance, electronic, and ambient styles.
                As an instrumentalist, I'm mainly a guitarist and drummer, with some background in tabla, piano and flute. I like picking up any other instruments when I can.
            </p>
            <p>
                One of my main musical interests is sampling as an artform. I have talked about it extensively in <a href="https://www.youtube.com/watch?v=eZwqpWUT0k4" className="App-link">a TEDxTalk I delivered</a> during my college years, 
                and it's a curiosity that informs all of my musical output at large.
            </p>
            <p>
                Check out my <a href="https://soundcloud.com/suburban-york" className="App-link">beatmaking Soundcloud</a> for an idea of my instrumental style.
            </p>
            <p>
                You can also follow my solo music project <span className="App-fmt">five mango trees</span> on <a href="https://fivemangotrees.bandcamp.com" className="App-link">Bandcamp</a> or on <a href="https://distrokid.com/hyperfollow/fivemangotrees/tiger-balm" className="App-link">any of your streaming services</a>.
            </p>
            <BandcampWidget />
            <p>
                I also avidly make remixes and mashups, an extension of a college pastime working with Indian fusion dance teams. Some of my mixing work is on <a href="https://soundcloud.com/bhargav-anni" className="App-link">Soundcloud</a> and I will be updating my <a href="https://www.youtube.com/@bhrg" className="App-link">YouTube channel</a> as I make more mixes.
            </p>
            <p>
                I have composed scores for film projects and bumper music for a podcast. Check out some examples of my compositions below.
            </p>
            <PlaylistWidget />
            <p>
                If you have any production / music needs, <Link to="/contact" className="App-link">reach out!</Link> I'd love to see if I can be of any help!
            </p>
            <p style={headerStyling}>
                Writing
            </p>
            <p>
                I don't consider myself the best writer, but I'm an avid watcher of movies and reader of books and media criticism. 
                As part of this, I've been trying to improve my own writing with the exercise of putting down substantive thoughts about whatever work I'm consuming, 
                and composing bigger pieces to improve my own literacy and analysis.
            </p>
            <p>
                I occasionally post to a Substack for long form thoughts about whatever art I'm engaging with. Check it out at <a href="https://bhrg.substack.com/" className="App-link">bhrg.substack.com</a>.
            </p>
            <p>
                You can also <a href="https://letterboxd.com/steelestewartxo" className="App-link">follow me on Letterboxd</a> for briefer (but still intentioned) writing about what I'm watching.
            </p>
            <p style={headerStyling}>
                Coding
            </p>
            <p>
                I worked at Apple for 3 years as a software engineer, throughout which I was able to work on numerous projects related to iOS development, backend services and cloud infrastructure in a production setting.
                I developed backend improvements for iCloud, built internal tooling and APIs for Shazam infrastructure, and I also contributed native Swift code for Apple Podcasts and App Store on all Apple platforms. I gained production experience with the Swift, Go,
                Java, Bash, Javascript (Typescript), and Objective-C programming languages.  
            </p>
            <p>
                I built a game called <a className="App-link" href="https://sound-bits.com">Sound Bits</a> to automate a game that I play with my friends all of the time: naming songs as fast as I can.
            </p>
            <p>
                Sound Bites is built on a React frontend and an ASP.NET backend API that also uses a PostgreSQL database.
            </p>
            <p>
                Sound Bits also involves a <a className="App-link" href="https://sound-bits.com/chart-game">daily chart game</a> wherein you try to figure out the songs that topped the Billboard Hot 100 in a given weekend in chart history.
            </p>
            <p>
                I am also proficient in Python, SQL, React, Flutter, CSS, HTML, ASP.NET, C and C++, as well as Kubernetes, Amazon Web Services and Google Cloud Platform.
            </p>
            {/* <p>
                I'm building a site called Annotatify that connects with the Spotify API to write corresponding annotations to your playlists. 
                It is currently publically viewable but only usable by beta testers. 
                I hope to add more sophisticated Spotify profile integration and expansion to other services like Apple Music or Tidal shortly.
                <br/>
                <a href="https://www.annotatify.com/playlist/68KX2G5MHXhoyIy9E5OsAg" className="App-link">Check out an example annotated playlist here!</a>
            </p> */}
            <p>
                I continue to work on my own independent programming projects here and there, and will continue linking to anything as it becomes publicly available. 
                My current interest is learning about digital signal processing and plugin/VST development for music and audio applications.
            </p>
            <img src={scribble} alt="" style={{width:"22vh", marginTop:"5vh"}} onContextMenu={()=>{return false;}} draggable={false}/>
        </div>
    )
}

export default Work;